import { Heart, MessageCircle, Sparkles, Check, Infinity } from "lucide-react";

const icons = [Heart, MessageCircle, Sparkles, Check, Infinity];

export default function WhyLove({ t }) {
  return (
    <section
      id="love"
      data-testid="section-love"
      className="py-20 md:py-28 bg-[var(--beige-100)] border-y border-[rgba(110,30,43,0.07)] tk-section-anchor"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          <span className="tk-eyebrow">
            <span className="tk-divider" />
            {t.love.kicker}
            <span className="tk-divider" />
          </span>
          <h2 className="font-serif text-4xl sm:text-6xl mt-5 text-[var(--ink)] leading-tight">
            {t.love.title}
          </h2>
        </div>

        <div className="mt-16 text-center">
          <h3 className="font-serif text-4xl text-[var(--ink)]">{t.love.whyTitle}</h3>
          <p className="mt-4 text-lg text-[var(--ink-soft)] max-w-2xl mx-auto">
            {t.love.whyBody}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5 mt-10">
          {t.love.items.map((item, index) => {
            const Icon = icons[index];
            return (
              <article
                key={item}
                data-testid={`love-item-${index + 1}`}
                className="tk-card p-6 text-center"
              >
                <span className="w-16 h-16 mx-auto rounded-full bg-[var(--beige-100)] text-[var(--burgundy)] flex items-center justify-center">
                  <Icon size={32} strokeWidth={1.7} />
                </span>
                <p className="text-[var(--ink)] leading-relaxed mt-5">{item}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
